import { ApiBind, Common } from './common.model';

export class Site extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'type' })
  type: string;
}
